

import React from "react";
import { Modal } from "react-bootstrap";
import "./Image_Modal.css";

const Image_Modal = ({ show, handleClose, image }) => {
  if (!image) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="gallery_modal"
    >
      <Modal.Body className="p-0 position-relative">

        {/* Close Button */}
        <button className="modal_close_btn" onClick={handleClose}>
          ×
        </button>

        {/* Full Image */}
        <img
          src={image}
          alt={"image"}
          className="modal_full_img"
        />

        {/* Title */}
        {/* <div className="modal_image_title">
          {image.title}
        </div> */}

      </Modal.Body>
    </Modal>
  );
};

export default Image_Modal;